import React from "react";

const STAGGER_MS = 90;
const MAX_STEPS = 5;

/**
 * Attributes that make an element fade and rise into view on scroll (styles in WebsiteTheme.style.js,
 * observer in SitePageShell). `index` staggers items in a row or grid.
 * variant: "up" (default), "left", "right" or "zoom".
 * Use on elements you cannot wrap (list items); use <Reveal> for everything else.
 */
export const revealProps = (variant = "up", index = 0) => ({
	"data-reveal": variant,
	style: { "--reveal-delay": `${Math.min(index, MAX_STEPS) * STAGGER_MS}ms` },
});

/**
 * Wrapper version of revealProps. Keep hover transforms on a child, not on this element,
 * so the reveal and the hover never fight over `transform`.
 */
const Reveal = ({ as: Tag = "div", variant = "up", index = 0, className, children, ...rest }) => (
	<Tag className={className} {...revealProps(variant, index)} {...rest}>
		{children}
	</Tag>
);

export default Reveal;
